import React from 'react'

import { getFilterData, getLabel, getLineGraphColor } from '../util'

import './GraphLegend.css'

export interface GraphLegendProps {
  type: string
  selected: string[]
}

export const GraphLegend: React.FC<GraphLegendProps> = ({ type, selected }) => {
  return (
    <div className="legends" data-testid="legends">
      {selected.length > 1 &&
        selected.map((legend) => {
          return (
            <div className="legend" key={legend} data-testid={`${legend}-legend`}>
              <span className="icon">
                <svg
                  className="legend-circle"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  style={{ color: getLineGraphColor(selected.length > 1 ? legend : '') }}
                >
                  <circle cx="12" cy="12" r="12" />
                </svg>
              </span>
              <span className="text">{getLabel(legend, getFilterData(type))}</span>
            </div>
          )
        })}
    </div>
  )
}
